const productTypeApiErrorMappings = {
  name: { 'value is not unique': 'Sudah terdaftar di sistem.' },
}

export default productTypeApiErrorMappings
